import produce from 'immer';

const INITIAL_STATE = {
  menu: true,
};

export default function dash(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@dash/MENU_SIDEBAR': {
        draft.menu = !draft.menu;
        break;
      }
      default:
    }
  });
}
